import { PartialId } from '@attain-apps/string-builder'

import * as core from '../../../../../../../../../core'
import * as sponsors from '../../../../sponsors'
import * as award from '../award'

export const RESOURCE = {
  payload: {
    canBeOptional: true,
    context: core.dms.models.Attribute.Id.Context.from({
      context: award.RESOURCE.payload.dimension.partialId,
      partialId: award.RESOURCE.payload.partialId,
      type: core.dms.models.Type.Entity,
    }),
    description: 'TODO',
    isOptional: true,
    name: 'Sponsor',
    partialId: PartialId.Standard.create('sponsor'),
    type: {
      dimensionId: core.dms.models.Dimension.Id.from(sponsors.RESOURCE.payload),
    },
  },
  type: core.quiver.Resource.Type.DmsAttribute,
} as const satisfies core.quiver.Resource<core.quiver.Resource.Type.DmsAttribute>
